import LicenseHeader from './container'
export default LicenseHeader



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseHeader/index.js